export const CONVERSATION_LRG_BLOCK_HEIGHT = '110px';
export const CONVERSATION_SM_BLOCK_HEIGHT = '20px';
